import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import JSEncrypt from 'jsencrypt';


@Injectable()
export class EncryptionUtil {

  crypt: JSEncrypt;

  constructor() {

  }

  public encryptMessage(name: string, pubKey: string): string | false {
    this.crypt = new JSEncrypt({});
    this.crypt.setKey(pubKey);
    return this.crypt.encrypt(name);
  }

  /** Return a random password. */
  public getRandomPassword() {
    return CryptoJS.lib.WordArray.random(10).toString();
  }

  /**
   * Encrypt received text with AES-256 (CryptoJS.PBKDF2 key), using a custom password.
   * Return a secure message request (json): {m : 'Encrypted Message', p : 'password',  s : 'salt', i : 'iv'}
   * @param text
   */
  public createSecureRequest(text, pass, pubKey) {
    const salt = CryptoJS.lib.WordArray.random(128 / 8);
    const iv = CryptoJS.lib.WordArray.random(128 / 8);

    const key = CryptoJS.PBKDF2(pass, salt, {
      keySize: 256 / 32, // 256
      iterations: 100
    });

    const encrypted = CryptoJS.AES.encrypt(text, key, {
      iv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC
    });

    const password = this.encryptMessage(pass, pubKey); // RSA
    return { m: encrypted.toString(), p: password, s: salt.toString(), i: iv.toString() };
  }

  /**
   * Decrypt a secure message response with AES-256 (CryptoJS.PBKDF2 key), using a custom password.
   * SecureResponse parameter format (json): {m : 'Encrypted Message', s : 'salt', i : 'iv'}
   */
  public resolveSecureResponse(secureResponse, pass) {
    const text = secureResponse.m;
    const salt = CryptoJS.enc.Hex.parse(secureResponse.s);
    const iv = CryptoJS.enc.Hex.parse(secureResponse.i);

    const key = CryptoJS.PBKDF2(pass, salt, {
      keySize: 256 / 32, // 256
      iterations: 100
    });

    const decrypted = CryptoJS.AES.decrypt(text, key, {
      iv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC
    });

    return decrypted.toString(CryptoJS.enc.Utf8); // stringify
  }
}
